import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    IconButton,
    Stack
} from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CloseIcon from '@mui/icons-material/Close';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 402,
    height: 234,
    bgcolor: 'background.paper',
    borderRadius: 1,
    boxShadow: 24,
    padding: '30px 42px 62px 42px',
    outline: 'none',
    textAlign: 'center',
};

const InformationTextA2ErrorModal = () => {
    const [open, setOpen] = useState(true);

    const handleClose = () => setOpen(false);

    return (
        <Modal
            open={open}
            onClose={() => { }}
            disableEscapeKeyDown
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
            hideBackdrop
        >
            <Box sx={style}>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        top: 6,
                        right: 12,
                        color: 'grey.700',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                    <WarningRoundedIcon sx={{ color: '#D32F2F' }} />
                    <Typography id="modal-title" variant="h6" sx={{ color: '#D32F2F', fontWeight: 700, fontFamily: 'Roboto', fontSize: '20px', position: 'relative', left: '-57px' }}>
                        Gaps in stimulus text
                    </Typography>
                </Stack>

                <Typography id="modal-description" sx={{ mb: 3, fontSize: '20px', lineHeight: '1.3rem', top: '6px', fontFamily: 'Roboto', position: 'relative' }}>
                    Add underscores _ to indicate a <br/> gap in the stimulus text.<br/>Example, Page 1 and Page 2 must <br/> have the right number of gaps.
                </Typography>

                <Button variant="text" sx={{ fontSize: '20px', color: 'black', fontWeight: 400 }} onClick={handleClose}>
                    CLOSE
                </Button>
            </Box>
        </Modal>
    );
};

export default InformationTextA2ErrorModal;